import { Row, Col, Form } from "react-bootstrap";
import CustomBadge from "@/components/desktop/badge/CustomBadge";
import Select from "react-select";

import classes from "../../maintainers.module.scss";

import { customStyles } from "../applications.constants";

import { decimalNegativeValidate, formatMilesDecimal, formatMilesDecimalNew, validRoles } from "@/services/Utils";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const ApplicationsFields = ({
	application,
	estatesParents,
	estates,
	categories,
	species,
	varieties,
	quarters,
	businessCenter,
	operators,
	hauliers,
	setApplication,
}) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	let text_unit = "Kg";
	if (application && application.inventory && application.inventory.product) {
		if (application.inventory.product.unit_measurement === "u") {
			text_unit = "Un";
		}
		if (application.inventory.product.unit_measurement === "cc") {
			text_unit = "L";
		}
	}

	return (
		<Row className={classes.row_form}>
			<Col md={12} xs={12}>
				{Number(application.entry) === 1 ? <CustomBadge variant="success">Entrada</CustomBadge> : <CustomBadge variant="warning">Salida</CustomBadge>}

				{Number(application.empty_container) === 1 ? (
					<CustomBadge variant="info" style={{ marginLeft: "5px" }}>
						Vacío
					</CustomBadge>
				) : (
					""
				)}

				{Number(application.not_used) === 1 ? (
					<CustomBadge variant="info" style={{ marginLeft: "5px" }}>
						No Usado
					</CustomBadge>
				) : (
					""
				)}
			</Col>

			<Col md={4} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Producto</Form.Label>

					<Form.Control
						value={application && application.inventory && application.inventory.product ? application.inventory.product.tradename : ""}
						readOnly={true}
						type="text"
					/>
				</Form.Group>
			</Col>

			{isAdmin && (
				<Col md={4} xs={12}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>Contenido Neto</Form.Label>

						<Form.Control
							value={`${
								application && application.inventory
									? application.inventory.container_content
										? formatMilesDecimalNew(application.inventory.container_content)
										: 0
									: ""
							} ${text_unit}`}
							readOnly={true}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			<Col md={4} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Código</Form.Label>

					<Form.Control
						value={application && application.inventory && application.inventory.code ? application.inventory.code : ""}
						readOnly={true}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={4} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Fecha</Form.Label>

					<Form.Control
						value={application && application.weight_date ? application.weight_date : ""}
						type="date"
						onChange={(e) => {
							setApplication({
								...application,
								weight_date: e.target.value,
							});
						}}
					/>
				</Form.Group>
			</Col>

			<Col md={4} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Hora</Form.Label>

					<Form.Control
						value={application && application.weight_time ? application.weight_time : ""}
						type="time"
						onChange={(e) => {
							setApplication({
								...application,
								weight_time: e.target.value,
							});
						}}
					/>
				</Form.Group>
			</Col>

			<Col md={4} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Usuario</Form.Label>

					<Form.Control value={application && application.user && application.user.name ? application.user.name : ""} readOnly={true} type="text" />
				</Form.Group>
			</Col>

			{isAdmin && (
				<Col md={4} xs={6}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>Densidad</Form.Label>

						<Form.Control
							value={
								application && application.inventory && application.inventory.inventory_density
									? formatMilesDecimal(application.inventory.inventory_density)
									: ""
							}
							readOnly={true}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			{isAdmin && (
				<Col md={4} xs={6}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>Peso Envase (g)</Form.Label>

						<Form.Control
							value={
								application && application.inventory && application.inventory.weight_container
									? formatMilesDecimal(application.inventory.weight_container)
									: ""
							}
							readOnly={true}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			<Col md={2} xs={6}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Vacío</Form.Label>

					<Form.Check
						type="switch"
						id={`switch_vacio`}
						checked={application && application.empty_container ? true : false}
						onChange={(_e) => {
							setApplication({
								...application,
								empty_container: !application.empty_container,
							});
						}}
					/>
				</Form.Group>
			</Col>

			<Col md={2} xs={6}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>No Utilizado</Form.Label>

					<Form.Check
						type="switch"
						id={`switch_no_usado`}
						checked={application && application.not_used ? true : false}
						onChange={(_e) => {
							setApplication({
								...application,
								not_used: !application.not_used,
							});
						}}
					/>
				</Form.Group>
			</Col>

			{isAdmin && (
				<Col md={4} xs={12}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>Peso Balanza (Kg)</Form.Label>

						<Form.Control
							value={application && (application.weight || application.weight === 0) ? application.weight : ""}
							onChange={(e) => {
								setApplication({
									...application,
									weight: e.target.value,
								});
							}}
							onKeyDown={decimalNegativeValidate}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			{isAdmin && (
				<Col md={4} xs={12}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>{Number(application.entry) === 1 ? "Contenido Utilizado" : "Contenido Salida"} (g)</Form.Label>

						<Form.Control
							value={
								Number(application.entry) === 1
									? application.weight_used
										? formatMilesDecimal(application.weight_used)
										: ""
									: application.output_weight
										? formatMilesDecimal(application.output_weight)
										: ""
							}
							readOnly={true}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			{isAdmin && (
				<Col md={4} xs={12}>
					<Form.Group className={classes.group_form}>
						<Form.Label className={classes.label}>{Number(application.entry) === 1 ? "Contenido Utilizado" : "Contenido Salida"} (cc)</Form.Label>

						<Form.Control
							value={
								Number(application.entry) === 1
									? application.weight_used
										? formatMilesDecimal(
												(application.weight_used -
													(application && application.inventory && application.inventory.weight_container
														? application.inventory.weight_container
														: 1)) /
													(application && application.inventory && application.inventory.inventory_density
														? application.inventory.inventory_density
														: 1),
											)
										: ""
									: application.output_weight
										? formatMilesDecimal(
												(application.output_weight -
													(application && application.inventory && application.inventory.weight_container
														? application.inventory.weight_container
														: 1)) /
													(application && application.inventory && application.inventory.inventory_density
														? application.inventory.inventory_density
														: 1),
											)
										: ""
							}
							readOnly={true}
							type="text"
						/>
					</Form.Group>
				</Col>
			)}

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Campo</Form.Label>

					<Select
						isMulti
						value={
							estatesParents &&
							estatesParents.filter(
								(estate_parent) => application && application.estates_parents && application.estates_parents.includes(estate_parent.value),
							)
						}
						placeholder={<div>Seleccione Campo</div>}
						options={estatesParents}
						onChange={(value) => {
							let newEstatesParents = [];
							value &&
								value.map((estate_parent) => {
									newEstatesParents.push(estate_parent.value);
									return null;
								});

							setApplication({
								...application,
								estates_parents: newEstatesParents,
								estates: [],
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Bodega</Form.Label>

					<Select
						isMulti
						value={estates && estates.filter((estate) => application && application.estates && application.estates.includes(estate.value))}
						placeholder={<div>Seleccione Bodega</div>}
						options={
							application.estates_parents && application.estates_parents.length > 0
								? estates.filter((estate) => application.estates_parents.includes(estate.estate_parent_id))
								: estates
						}
						onChange={(value) => {
							let newEstates = [];
							value &&
								value.map((estate) => {
									newEstates.push(estate.value);
									return null;
								});

							setApplication({
								...application,
								estates: newEstates,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Categorías</Form.Label>

					<Select
						isMulti
						value={
							categories && categories.filter((estate) => application && application.categories && application.categories.includes(estate.value))
						}
						placeholder={<div>Seleccione Categorías</div>}
						options={categories}
						onChange={(value) => {
							let newCategories = [];
							value &&
								value.map((category) => {
									newCategories.push(category.value);
									return null;
								});

							setApplication({
								...application,
								categories: newCategories,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Paso 1</Form.Label>

					<Select
						isMulti
						value={species && species.filter((estate) => application && application.species && application.species.includes(estate.value))}
						placeholder={<div>Seleccione Paso 1</div>}
						options={species}
						onChange={(value) => {
							let newSpecies = [];
							value &&
								value.map((specie) => {
									newSpecies.push(specie.value);
									return null;
								});

							setApplication({
								...application,
								species: newSpecies,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Paso 2</Form.Label>

					<Select
						isMulti
						value={varieties && varieties.filter((estate) => application && application.varieties && application.varieties.includes(estate.value))}
						placeholder={<div>Seleccione Paso 3</div>}
						options={varieties}
						onChange={(value) => {
							let newVarieties = [];
							value &&
								value.map((variety) => {
									newVarieties.push(variety.value);
									return null;
								});

							setApplication({
								...application,
								varieties: newVarieties,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Paso 3</Form.Label>

					<Select
						isMulti
						value={quarters && quarters.filter((estate) => application && application.quarters && application.quarters.includes(estate.value))}
						placeholder={<div>Seleccione Paso 3</div>}
						options={quarters}
						onChange={(value) => {
							let newQuarters = [];
							value &&
								value.map((quarter) => {
									newQuarters.push(quarter.value);
									return null;
								});

							setApplication({
								...application,
								quarters: newQuarters,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Centro de Costo</Form.Label>

					<Select
						isMulti
						value={
							businessCenter &&
							businessCenter.filter((bc) => application && application.business_center && application.business_center.includes(bc.value))
						}
						placeholder={<div>Centros de Costo</div>}
						options={businessCenter?.filter((bc) => bc.estates?.some((e) => application.estates?.includes(e)))}
						onChange={(value) => {
							let newBCs = [];
							value &&
								value.map((bc) => {
									newBCs.push(bc.value);
									return null;
								});

							setApplication({
								...application,
								business_center: newBCs,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Operadores</Form.Label>

					<Select
						isMulti
						value={
							operators && operators.filter((operator) => application && application.operators && application.operators.includes(operator.value))
						}
						placeholder={<div>Operadores</div>}
						options={operators}
						onChange={(value) => {
							let newOperators = [];
							value &&
								value.map((operator) => {
									newOperators.push(operator.value);
									return null;
								});

							setApplication({
								...application,
								operators: newOperators,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Transportistas</Form.Label>
					<Select
						isMulti
						value={hauliers && hauliers.filter((operator) => application && application.hauliers && application.hauliers.includes(operator.value))}
						placeholder={<div>Transportistas</div>}
						options={hauliers}
						onChange={(value) => {
							let newWarehouses = [];
							value &&
								value.map((operator) => {
									newWarehouses.push(operator.value);
									return null;
								});

							setApplication({
								...application,
								hauliers: newWarehouses,
							});
						}}
						components={{
							NoOptionsMessage,
						}}
						styles={customStyles}
						menuPlacement="auto"
					/>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default ApplicationsFields;
